import {React, useEffect} from 'react'
import logo from './img/lgo.png'
import './scroll.css'

function Nav() {
    useEffect(() => {
        const handleScroll = () => {
          const navbarDPHU = document.querySelector('.navbarDPHU');
          const logo = document.querySelector('.logo');
          const logox = document.querySelector('.logo-text');

          if (window.scrollY > 10) {
            navbarDPHU.classList.add('scrolled');
            logo.classList.add('hide-logo');
            logox.classList.add('hide-logo');
          } else {
            navbarDPHU.classList.remove('scrolled');
            logo.classList.remove('hide-logo');
            logox.classList.remove('hide-logo');
          }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

        function scrollToTop(event) {
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
          event.preventDefault();
          document.getElementById("scrollableDiv").scrollTo({
              top: 0,
              behavior: 'smooth'
          });
      }

    return (
      <div className='DPHU'>
        <div className="top-nav">
            <div className='logo-text'>
              <a href="adminDPHU">
                <img src={logo} className="logo" style={{ width: '5%', position: 'fixed', top: 0, zIndex: 1}} />
              </a>
                <a href="adminDPHU" id='log-txt' className="logtex"><strong>DISTANT PRODUCTION HOUSE UNIVERSITY</strong></a>
            </div>
          <nav className="navbarDPHU">
          <ul className="nav-links">
                  {/* <li style={{ marginLeft: "350px" }}><a href="#academic"><strong>Academique</strong></a></li> */}
                  {/* <li><a href="#home"><strong>Bibliotheque</strong></a></li> */}
                  {/* <li><a href="#home"><strong>Inscription</strong></a></li>
                  <li><a href="gallery"><strong>Gallery</strong></a></li> */}
                  <li><a href="#home"><strong>Contact</strong></a></li>
                  <li><a href="login"><strong>Login</strong></a></li>
              </ul>
          </nav>
          <br/>
          <br/>
        </div>
      </div>
    )
}

export default Nav;